<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CAlert show color="warning" v-if="hasWarning">
          {{ hasWarning }}
        </CAlert>
        <CCard>
          <CCardHeader>
            <CButton :color="saveButton.color" :disabled="saveDisabled" @click="saveData" class="float-right">
              <CIcon :name="saveButton.icon" size="sm" class="mr-1" />{{ saveButton.text }}
            </CButton>
            <h3>
              Tabs
            </h3>
          </CCardHeader>
          <CCardBody>
             <CAlert color="secondary" closeButton>
              <CIcon name="cil-lightbulb"/>
              <span class="pl-2">Tabs appear at the bottom of the screen in the app, you can select which links to show here.</span>
            </CAlert>
            <CRow v-if="!isNew" class="mt-4">
              <CCol>
                <CCardGroup deck>
                  <CCard>
                    <CCardHeader>
                      <strong>Add links to Tab bar</strong>
                    </CCardHeader>
                    <CCardBody>
                      <CListGroup>
                        <CListGroupItem
                          v-for="(item, index) in allItems"
                          :key="index"
                          @click="addItem(item.id)"
                          :data-idx="index"
                          style="cursor:pointer"
                        >
                          {{ item.title }}
                          <CBadge color="danger">link</CBadge>
                          <cIcon class="float-right" name="cilPlaylistAdd" />
                        </CListGroupItem>
                      </CListGroup>
                    </CCardBody>
                  </CCard>

                  <CCard>
                    <CCardHeader>
                      <strong>Links in Tab bar</strong>
                    </CCardHeader>
                    <CCardBody>
                      <ul
                        v-if="items.length > 0"
                        class="list-group"
                        v-sortable="$options.sortOptions"
                        @sorted="moveItem"
                      >
                        <li v-for="(item, index) in items" :key="item.id" :data-idx="index" class="list-group-item">
                          <CRow>
                            <CCol sm="11" class="sort-handle">
                              {{ item.title }}
                              <CBadge color="danger">link</CBadge>
                            </CCol>
                            <CCol sm="1">
                              <CDropdown toggler-text="  " class="float-right" :caret="true" size="sm">
                                <CDropdownItem @click="removeItem(item.id)">Remove item</CDropdownItem>
                                <CDropdownDivider />
                                <CDropdownItem @click="goItem(item.id)">Go to item</CDropdownItem>
                              </CDropdown>
                            </CCol>
                          </CRow>
                        </li>
                      </ul>
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import _ from 'lodash'
import Sortable from '../../directives/Sortable'
import { PIXEL } from '../../constants'

export default {
  name: 'Tabs',
  sortOptions: {
    draggable: '.list-group-item',
    handle: '.sort-handle',
  },
  directives: { Sortable },
  data() {
    return {
      isNew: false,
      items: [],
      allItems: [],
      saveDisabled: true,
      saveButtons: [
        { color: 'secondary', text: 'Saved', icon: 'cil-check-alt' },
        { color: 'danger', text: 'Save Tabs', icon: 'cil-save' },
      ],
      search: '',
      itemHighlightIndex: [],
      pixel: PIXEL,
      item_type: 'link',
      hasWarning: false,
      settings: this.$settings,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    items: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal.length == 0) {
          return
        }
        this.saveDisabled = false
      },
    },
    search: {
      handler() {
        this.triggerSearch()
      },
    },
  },
  computed: {
    saveButton() {
      return this.saveButtons[this.saveDisabled ? 0 : 1]
    },
  },
  methods: {
    getData() {
      this.$api.get(`tabs`).then(response => {
        this.items = response.data.tabs
        this.getItems()
      })
    },

    saveData() {
      this.hasWarning = false
      const ids = this.items.map(b => b.id)
      this.$api.post(`tabs`, { ids }).then(() => (this.saveDisabled = true))
    },

    addItem(id) {
      const item = this.allItems.find(it => it.id === id)
      this.items.push(item)
      this.allItems = this.allItems.filter(it => it.id !== id)
    },

    removeItem(id) {
      this.items = this.items.filter(it => it.id !== id)
      this.getItems()
    },

    moveItem(ev) {
      const { oldIndex, newIndex } = ev
      this.items.splice(newIndex, 0, this.items.splice(oldIndex, 1)[0])
    },

    getItems() {
      this.isLoading = true
      this.$api.get(`links/?limit=100`).then(response => {
        this.allItems = this.parseItems(response.data)
        this.isLoading = false
      })
    },

    parseItems(data) {
      // filter out items that are already in the block
      const ids = this.items.map(b => b.id)
      let allItems = data.links.filter(val => {
        if (ids.includes(val.id)) {
          return false
        } else {
          return true
        }
      })
      return allItems
    },

    triggerSearch: _.debounce(function() {
      this.getItems()
    }, 500),

    goItem(id) {
      this.$router.push({ path: `/links/${id}` })
    },
  },
}
</script>

<style>
.list_image {
  width: 36px;
  height: 36px;
}
.autofill-items {
  background-color: #e0e0e0;
  opacity: 0.5;
}
.sort-handle {
  cursor: grab;
}
.max-items {
  background-color: #ebedef;
}
</style>
